function ErrorSignInPage() {
    return (  
        <>
        <img src='../assetsTemplates/templateForm/images/errorsignin.png' className="img-fluid offset-md-1" style={{ width: "70%", height: "70%"}} alt=""/>
        </>
    );
}

export default ErrorSignInPage;